<template>
  <f7-block class="no-padding">
    <DxForm
      id="form"
      :col-count="1"
    >
      <DxSimpleItem
        :editor-options="{
          items: areaList,
          displayExpr:'name',
          valueExpr:'id',
          searchEnabled: true,
          onValueChanged: changeLevel,
          visible: false,
        }"
        editor-type="dxSelectBox"
      />
    </DxForm>
  </f7-block>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
} from 'devextreme-vue/form';
import * as overlay from 'devextreme/ui/overlay';
import Api from '../../services/Api';
import EventBus from '../../js/event-bus';

export default {
  name: 'DxLocationSelector',
  components: {
    DxForm,
    DxSimpleItem,
  },
  props: {
    startLevel: { type: Number, default: 0 },
    endLevel: { type: Number, default: 1 },
    events: { type: Array, default: () => ['updateLocations'] },
  },
  data() {
    return {
      seletedFarm: { type: Object, default: null },
      children: [],
      locationsTree: [],
      filteredLocations: [],
      temporalAreaList: [],
      locations: [],
    };
  },
  computed: {
    ...mapState('Reporting', ['selectedFarmList', 'currentLevel', 'areaList']),
    ...mapGetters('Reporting', ['formattedTree']),
  },
  async beforeMount() {
    overlay.baseZIndex(9999);
    try {
      this.setCurrentLevel(this.startLevel);
      this.setCurrentLocation(null);
      this.setCurrentLocationName(null);
      this.setSelectedFarmList([]);
      this.setAreaList([]);
      await this.loadLocationsTree();
      this.emitEvents();
    } catch (error) {
      const message = this.$helpers.getFilteredErrorMessage(error);
      if (message.includes('default_') && !message.includes('404')) {
        this.$f7.dialog.alert(message.split('_').pop());
      } else if (!message.includes('404')) {
        this.$f7.dialog.alert(this.$t(message));
      }
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    changeLevel(e) {
      const newLocations = [];
      this.temporalAreaList = [];
      this.setCurrentLocation(e.value);
      let parentTemporalAreaList = '';
      let lastLevelLocation = '';
      let lastLevelAreaList = {};
      for (const farm of this.locations) {
        if (farm.bd_id === e.value) {
          if (farm.name !== this.$t('DxLocationSelector_ParentLevel')) {
            this.seletedFarm = farm;
            this.setCurrentLocationName(farm.name);
            this.setCurrentLevel(farm.level);
            lastLevelLocation = farm.bd_id; // id de localizacion actual
            lastLevelAreaList = { id: farm.bd_id, name: farm.name, area: farm.area }; // datos loc actual
            this.locations = farm.children;
            parentTemporalAreaList = {
              id: `${farm.level}`.repeat(24), name: this.$t('DxLocationSelector_ParentLevel'), area: 0, level: farm.level,
            };
            newLocations.push(`${farm.level}`.repeat(24)); // nivel superior
            this.temporalAreaList.push(parentTemporalAreaList);
          }
          break;
        }
      }
      if (parentTemporalAreaList === '') { // Ha hecho click en ir al padre
        const nivelPadre = parseInt(e.value[0], 10);
        // Cogemos todas las localizaciones del arbol con nivel padre
        let locationsLevelParent = [];
        if (nivelPadre > 0) {
          // Si el nivel padre es mayor que la raiz, no debemos coger todos, sino los que vengan del abuelo del nodo actual
          const locationGrandParent = this.formattedTree.filter(
            (element) => element.level === (nivelPadre - 1) // Filtramos por nivel abuelo
            && element.children.filter((child) => child.bd_id === e.previousValue).length > 0,
          ); // Donde el abuelo tiene como hijo el valor previo del select
          if (locationGrandParent.length > 0) {
            locationsLevelParent.push({
              bd_id: `${locationGrandParent[0].level}`.repeat(24), name: this.$t('DxLocationSelector_ParentLevel'), area: 0, level: locationGrandParent[0].level,
            });
            locationsLevelParent = locationsLevelParent.concat(locationGrandParent[0].children); // Establecemos los hijos del abuelo (padre del nodo actual + hermanos)
          }
        } else {
          // Todos los nodos del nivel 0 (raíz)
          locationsLevelParent = this.formattedTree.filter((element) => element.level === nivelPadre);
        }
        // Añadimos todas las localizaciones del arbol con nivel padre al select.
        locationsLevelParent.forEach((element) => {
          newLocations.push(element.bd_id);
          this.temporalAreaList.push({
            id: element.bd_id, name: element.name, area: element.area, level: element.level,
          });
        });
        this.locations = locationsLevelParent;
        this.updateLocations(newLocations, this.temporalAreaList);
        return;
      }

      if (this.currentLevel === this.endLevel) {
        newLocations.push(lastLevelLocation);
        this.temporalAreaList.push(lastLevelAreaList);
        this.updateLocations(newLocations, this.temporalAreaList);
        return;
      }
      if (this.currentLevel > this.endLevel) {
        return;
      }
      for (const child of this.seletedFarm.children) {
        newLocations.push(child.bd_id);
        this.temporalAreaList.push({ id: child.bd_id, name: child.name, area: child.area });
      }
      this.updateLocations(newLocations, this.temporalAreaList);
    },
    emitEvents() {
      for (const event of this.events) {
        EventBus.$emit(event);
      }
    },
    updateLocations(selectedFarms, newAreaList) {
      this.setSelectedFarmList(selectedFarms);
      this.setAreaList(newAreaList);
      this.emitEvents();
    },
    async loadLocationsTree() {
      const xhr = await Api.getTreeLocation();
      const locations = JSON.parse(xhr.response);
      this.setLocationsTree(locations);
      this.locations = locations;
      for (const location of locations) {
        this.setCurrentLocation(location.bd_id);
        this.setCurrentLocationName(location.name);
        this.filterByLevel(this.currentLevel, location);
      }
      this.setSelectedFarmList(this.selectedFarmList.filter(this.onlyUnique));
      this.setAreaList(this.removeDuplicatesAreas());
    },
    filterByLevel(level, locationsList) {
      this.filteredLocations = [];
      this.temporalAreaList = [];
      if (level > 0) {
        for (const farm of locationsList.children) {
          this.viewChildren(farm, locationsList, level);
        }
      } else {
        this.filteredLocations.push(locationsList.bd_id);
        this.temporalAreaList.push({ id: locationsList.bd_id, name: locationsList.name, area: locationsList.area });
      }
      this.setSelectedFarmList(this.selectedFarmList.concat(this.filteredLocations));
      this.setAreaList(this.areaList.concat(this.temporalAreaList));
    },
    viewChildren(item, locations, level) {
      if (item.level === level) {
        this.filteredLocations.push(item.bd_id);
        this.temporalAreaList.push({ id: item.bd_id, name: item.name, area: item.area });
        return;
      }

      for (let i = 0; i < item.children.length; i += 1) {
        this.viewChildren(item.children[i], locations);
      }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    onlyUniqueArea(value, index, self) {
      return self[index].id !== value.id;
    },
    removeDuplicatesAreas() {
      return this.areaList.filter((obj, pos, arr) => arr.map((mapObj) => mapObj.id).indexOf(obj.id) === pos);
    },
    ...mapActions('Reporting',
      ['setSelectedFarmList', 'setAreaList',
        'setCurrentLevel', 'setCurrentLocation',
        'setLocationsTree', 'setCurrentLocationName']),
  },
};
</script>

<style lang="scss">
</style>
